export const ZoomIn = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="13" cy="13" r="10" stroke="currentColor" stroke-width="2"/>
<path d="M13 8V18" stroke="currentColor" stroke-width="2"/>
<path d="M18 13L8 13" stroke="currentColor" stroke-width="2"/>
<path d="M28.2817 28.312L20 20" stroke="currentColor" stroke-width="2"/>
</svg>`;
